import { AppHelper } from "../../appHelper.js"
import { StringKeyDictionary } from "../../commonInterfaces.js";
import { Helper } from "../util/helper.js";
import { FAIcon } from "./faIcon.js";
import React from "react";

export class FileUpload extends React.Component<FileUploadProps, FileUploadState> {
    private _icuh = Helper;
    private _uploadInputRef = null;
    private _uploadRef: kendo.ui.Upload = null;
    private _contentRef = null;
    common = new AppHelper();
    translations: StringKeyDictionary<string> = null;
    uploadOptions: kendo.ui.UploadOptions = {};

    constructor(props) {
        super(props);
        this.state = {
            uploadEnabled: false,
            file: null,
            countFiles: 0
        };
    }


    private _createUpLoadButton = () => {
        return (
            <div style={{ display: "flex", justifyContent: "center" }} className={this.state.uploadEnabled ? "fileUpload__button" : ""} onClick={this.upload}>
                <FAIcon name="upload" style={{ fontSize: "xx-large", color: this.state.uploadEnabled ? "black" : "#c9c9c9" }} />
            </div>);
    }


    private _doOnSelect = (kendoEvent: kendo.ui.UploadSelectEvent) => {
        const file = kendoEvent.files[0];

        const validUpload = this._icuh.hasValue(file) && this._validate(file);
        if (validUpload) {
            if (this.props.onFileChange != undefined) {
                this.props.onFileChange(file);
            }
            this.setState({ file: file, uploadEnabled: true, countFiles: (this.state.countFiles + 1) });
        } else {
            kendoEvent.files.pop();
            kendoEvent.preventDefault();
            $(".k-upload-action.k-button.k-button-bare", this._contentRef).trigger("click");
            this.setState({ file: null, uploadEnabled: false });

        }
    }

    private _validate = (file: any): boolean => {

        if (this.props.validate == undefined) {
            return true;
        } else {
            return this.props.validate(file);
        }
    }

    upload = () => {
        if (this.state.uploadEnabled) {
            this.props.upload(this.state.file);

            this._uploadRef.removeAllFiles();
            this.setState({ file: null, uploadEnabled: false, countFiles: 0 });
        }
    }

    componentDidMount() {
        this.uploadOptions.select = this._doOnSelect;
        this.uploadOptions.remove = () => {
            this.setState({ file: null, uploadEnabled: false, countFiles: (this.state.countFiles - 1) }, () => {
                this.props.onFileChange(null)
            });
        }
        this.uploadOptions.multiple = Helper.getValueOrDefault(this.props.multiple, false);

        this._uploadRef = $(this._uploadInputRef).kendoUpload(this.uploadOptions).data("kendoUpload");

    }

    render() {
        const style: React.CSSProperties = Helper.getValueOrDefault(this.props.style, { width: "100%" });
        const upLoadButton = (Helper.getValueOrDefault(this.props.uploadButton, true)) ? this._createUpLoadButton() : null;
        const label = this.props.label ? <div style={{ marginTop: "5px", marginBottom: "2px" }}>{this.props.label}</div> : null;
        return (
            <div style={style}>
                {label}
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div ref={r => this._contentRef = r} style={{ width: "100%" }}>
                        <input name='fileUpload' type='file' ref={r => this._uploadInputRef = r} accept={Helper.hasValue(this.props.accept) ? this.props.accept.join(",") : ""} />
                    </div>
                    {upLoadButton}
                </div>
            </div>
        );
    }
}

interface FileUploadProps {
    style?: React.CSSProperties;
    uploadButton?: boolean;
    multiple?: boolean;
    label?: string;
    validate?: (file: File) => boolean;
    upload?: (file: File) => void;
    onFileChange?: (file: File) => void;
    accept?: string[]
}

interface FileUploadState {
    uploadEnabled: boolean;
    file: any;
    countFiles: number;
}

export interface File {
    extension: string;
    name: string;
    rawFile: any;
    size: number;
    uid: string;
}

